<template>
  <findPdf />
</template>

<script>
import findPdf from '@/components/findPdf.vue'

export default {
  name: 'HomeView',
  components: {
    findPdf
  }
}
</script>
